import { AxiosInstance } from '../services/auth/AxiosInstance';

// Send a new message to a chat
export const sendMessage = async (messageData) => {
    try {
        const response = await AxiosInstance.post('/messages', messageData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get all messages for a specific chat
export const getChatMessages = async (chatId, page = 1, limit = 50) => {
    try {
        const response = await AxiosInstance.get(`/messages/chat/${chatId}`, {
            params: { page, limit }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Mark chat messages as read
export const markMessagesAsRead = async (chatId) => {
    try {
        const response = await AxiosInstance.patch(`/messages/chat/${chatId}/read`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get total unread message count for current user
export const getUnreadMessageCount = async () => {
    try {
        const response = await AxiosInstance.get('/messages/unread-count');
        return response.data;
    } catch (error) {
        throw error;
    }
};
